import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/formation",
    name: "ForCompanies",
    component: () =>
      import( /* webpackChunkName: "about" */ "../views/ForCompanies.vue")
  }
];

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to) {
    if (to.hash) {
      // scroll to anchor
      return window.scrollTo({
        top: document.querySelector(to.hash).offsetTop,
        behavior: 'smooth'
      })
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
});

export default router;